// eslint-disable-next-line import/prefer-default-export
export const getDeliveryStatements = (state) => state.deliveryStatements;
